module.exports = __webpack_public_path__ + "static/media/edge.b106fc22.svg";